<template lang="pug">
div
  app-divider(label="Imóvel")
  el-row.pad5
    el-col(:span="12")
      p
        span.label {{labelsCadastro.imovel.denominacao}}
        span.breakText &nbsp {{filterNull(imovel.denominacao)}}
    el-col(:span="12")
      p
        span.label Área:
        span.breakText &nbsp {{formatterNumber(imovel.area)}}
    el-col(:span="12")
      p
        span.label Município:
        span.breakText &nbsp {{filterMunicipioNull(imovel.municipio)}}
  app-divider(label="Matrícula")
  el-row.pad5
    el-col(:span="12")
        p
          span.label CNS:
          span.breakText &nbsp {{filterNull(imovel.cnsMatricula)}}
    el-col(:span="12")
      p
        span.label Número:
        span.breakText &nbsp {{filterNull(imovel.numeroMatricula)}}
    el-col(:span="12")
      p
        span.label Livro:
        span.breakText &nbsp {{filterNull(imovel.livroMatricula)}}
    el-col(:span="12")
      p
        span.label Nº da folha:
        span.breakText &nbsp {{filterNull(imovel.numeroFolhaMatricula)}}
    el-col(:span="12",v-if="inputsExtraCadastro.imovel.dataMatricula")
      p
        span.label Data da matrícula:
        span.breakText &nbsp {{formatDate(imovel.dataMatricula)}}
  app-resumo-dados-titulo(:imovel="imovel", :hasFieldsExtras="hasFieldsExtras")
  app-resumo-documentos.margin-top(:documentos="imovel.documentos" codigoCadastro="imovel", :idCadastro="idCadastro")
</template>
<script>
import utils from '@/utils/utils'
import AppDivider from '../AppDivider'
import AppResumoDocumentos from './AppResumoDocumentos'
import AppResumoDadosTitulo from '@/components/resumo/AppResumoDadosTitulo'
const {labelsCadastro, inputsExtraCadastro} = require('@/utils/' + process.env.ESTADO + '/regrasCentral').default

export default {
  components: {
    AppDivider,
    AppResumoDocumentos,
    AppResumoDadosTitulo
  },
  data () {
    return {
      labelsCadastro,
      inputsExtraCadastro
    }
  },
  props: {
    imovel: {
      type: Object,
      required: true
    },
    idCadastro: {
      type: Number,
      required: true
    },
    hasFieldsExtras: {
      type: Boolean,
      required: false,
      default: true
    }
  },
  methods: {
    filterNull (atributo) {
      if (!atributo || atributo.length === 0) {
        return '-'
      }
      return atributo
    },
    filterMunicipioNull (municipio) {
      return municipio ? municipio.nome : '-'
    },
    formatterNumber (value) {
      const options = {
        prefix: '',
        suffix: '',
        thousands: '.',
        decimal: ',',
        precision: 4
      }

      return value > 0 ? utils.format(value, options) + ' hectare(s)' : '-'
    },
    formatDate (value) {
      return value ? utils.formatDate(value) : '-'
    }
  }
}
</script>
<style lang="scss" scoped>
.label {
  font-weight: bold;
}
.pad5 {
  padding: 25px 10px;
}

.margin-top {
  margin-top: 25px;
}

.breakText {
  word-break: break-all;
}

@media (max-width: 780px) {
  .pad5 {
    display: flex;
    flex-direction: column;
    width: 410px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/resumo/AppResumoImovel.vue